// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

export const marketoDefaultCss = `
// Main Form
>.mktoForm {
    width: 100% !important:
}
// Form Rows
>.mktoForm .mktoFormRow {
    display: flex !important;
    flex-wrap: wrap !important;
    min-width: 100% !important;
    margin: 0 !important;
}
// Form Fields
>.mktoForm input.mktoField,
select,
textarea {
    min-width: 100% !important;
}
// Removing extra offsets
>.mktoForm .mktoOffset {
    display: none !important;
}

// Removing gutter 
>.mktoForm .mktoGutter {
    display: none !important;
}

// Button Row
>.mktoForm .mktoButtonRow {
    width: 100% !important;
    margin: 0 !important;
}

// Button Wrapper
>.mktoForm .mktoButtonWrap {
    margin: 0 !important;
}
// FieldWrapper 
>.mktoForm .mktoFieldWrap {
    float: none !important;
}`;
